<template>
  <div>
    <div class="d-flex align-items-start">
      <b-icon :icon="titleIcon" :variant="variant" class="mr-2 mt-1"></b-icon>
      <div>
        <!-- Title -->
        <div class="font-weight-bold" :class="`text-${variant}`">
          {{ title }}
        </div>

        <!-- Question -->
        <div class="ml-2">
          <div class="font-weight-bold">{{ question.question }}</div>
          <div v-if="showDetails" class="text-muted small">
            <!-- Type -->
            <div>Type: {{ question.type }}</div>

            <!-- Theme -->
            <div>
              Thème:
              {{ question.theme ? question.theme.join(', ') : 'Aucun' }}
            </div>

            <!-- Response -->
            <div>Réponse: {{ question.response_ok }}</div>

            <!-- Audio -->
            <div v-if="question.mp3_question_path">
              <b-icon-check-circle-fill
                class="text-success"
              ></b-icon-check-circle-fill>
              Audio présent
            </div>
            <div v-else class="text-danger">
              <b-icon-x-circle-fill class="text-danger"></b-icon-x-circle-fill>
              Pas d'audio
            </div>

            <!-- Image -->
            <div v-if="question.image_path">
              <b-icon-check-circle-fill
                class="text-success"
              ></b-icon-check-circle-fill>
              Image présente
            </div>
            <div v-else>
              <b-icon-exclamation-circle-fill
                class="text-warning"
              ></b-icon-exclamation-circle-fill>
              Pas d'image
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      variant: {
        type: String,
        default: 'info',
      },
      titleClass: {
        type: String,
        default: 'text-info',
      },
      titleIcon: {
        type: String,
        default: 'info-circle-fill',
      },
      question: {
        type: Object,
        required: true,
      },
      showDetails: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>
